<template>
   <PageFrameContainer>
      <div v-html="getContent()"></div>
   </PageFrameContainer>
</template>

<script>
    import PageFrameContainer from "./components/PageFrameContainer";

    export default {
        name: "PrivacyPolicy",
        components: {PageFrameContainer},
        methods: {

            getContent() {
                return require(`@/locales/pages/privacy-${this.$i18n.locale.toLowerCase()}.html`);
            }
        }
    }
</script>

<style scoped lang="scss">
   @import "/theme/theme.scss";

</style>